import { render, staticRenderFns } from "./HistorialAsignaciones.vue?vue&type=template&id=2215b6dc&scoped=true&"
import script from "./HistorialAsignaciones.vue?vue&type=script&lang=js&"
export * from "./HistorialAsignaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215b6dc",
  null
  
)

export default component.exports